import type { Ref } from 'react'
import { InputOTP, InputOTPGroup, InputOTPSlot } from '#components/input-otp'

export function OtpInput(props: {
	value: string
	disabled: boolean
	onChange: (value: string) => void
	onComplete?: () => void
	ref?: Ref<HTMLInputElement>
}) {
	const handleChange = (value: string) => {
		if (props.disabled) {
			return
		}
		props.onChange(value)
		if (value.length === 6) {
			props.onComplete?.()
		}
	}
	return (
		<InputOTP
			autoFocus
			disabled={props.disabled}
			maxLength={6}
			onChange={handleChange}
			ref={props.ref}
			value={props.value}
		>
			<InputOTPGroup className='mx-auto'>
				<InputOTPSlot index={0} />
				<InputOTPSlot index={1} />
				<InputOTPSlot index={2} />
				<InputOTPSlot index={3} />
				<InputOTPSlot index={4} />
				<InputOTPSlot index={5} />
			</InputOTPGroup>
		</InputOTP>
	)
}
